<h1>{{ this.currentTitle }}</h1>

<h2>{{ 'teams.invite.create_account' | translate }}</h2>
<div>
  @if(displayMessage) {
    <div class="align-center">
      <div class="mb-10">
        <h2>French</h2>
        {{displayMessage}}, un lien de création de votre compte a été envoyé.<br>
        Veuillez vérifier votre boîte mail.
      </div>
      <div class="mb-50">
        <h2>English</h2>
        {{displayMessage}}, a link to create your account has been sent.<br>
        Please check your email.
      </div>
    </div>
  }

  <h2>{{ 'teams.invite.invite_members' | translate }}</h2>
  <button (click)="copyToClipboard(invitationLink())" nbButton fullWidth status="primary">{{ 'teams.invite.copy_link' | translate }}</button>
</div>
